import { useEffect, useState } from "react";
import { ShieldCheck, ShieldAlert } from "lucide-react";
import api from "@/lib/api";

// Aviso da auditoria noturna / reconciliação: verde quando tudo certo,
// âmbar quando a última execução encontrou e corrigiu anomalias.
export default function NightlyAuditBanner() {
  const [run, setRun] = useState(null);

  useEffect(() => {
    api.get("/admin/data/reconcile-history/last")
      .then((r) => setRun(r.data?.last_run || null))
      .catch(() => {});
  }, []);

  if (!run) return null;
  const res = run.results || {};
  const ghosts = (res.ghost_case_refs_cleaned || 0) + (res.ghost_row_refs_cleaned || 0);
  const parts = [
    [res.cases_removed_total, (n) => `${n} caso(s) obsoleto(s)/duplicado(s) removido(s)`],
    [ghosts, (n) => `${n} referência(s) fantasma limpa(s)`],
    [res.surgery_dates_normalized, (n) => `${n} data(s) de cirurgia normalizada(s)`],
    [res.hospital_links_repaired, (n) => `${n} vínculo(s) de hospital reparado(s) em mapas/casos`],
    [res.procedures_rematched, (n) => `${n} procedimento(s) reconhecido(s) em linhas antes órfãs`],
  ].filter(([n]) => (n || 0) > 0).map(([n, f]) => f(n));
  const anomalies = parts.length;
  const when = new Date(run.at).toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" });
  const label = run.trigger === "nightly" ? "Auditoria noturna" : "Reconciliação manual";

  if (anomalies === 0) {
    return (
      <div data-testid="nightly-audit-ok" className="flex items-center gap-2 text-xs text-emerald-700 bg-emerald-50 border border-emerald-100 rounded-md px-3 py-2">
        <ShieldCheck className="h-3.5 w-3.5 shrink-0" />
        <span>{label} de {when}: produção e financeiro conferidos — nenhuma anomalia encontrada.</span>
      </div>
    );
  }
  return (
    <div data-testid="nightly-audit-alert" className="flex items-start gap-2 text-sm text-amber-800 bg-amber-50 border border-amber-200 rounded-md px-3 py-2.5">
      <ShieldAlert className="h-4 w-4 shrink-0 mt-0.5" />
      <span>
        <strong>{label} de {when}</strong> encontrou e já corrigiu:{" "}
        {parts.join(", ")}
        . Vale conferir de onde vieram (mapas duplicados enviados 2×, profissionais excluídos, hospitais/procedimentos cadastrados depois dos mapas, etc.).
      </span>
    </div>
  );
}
